import React, { useState, useCallback } from 'react'
import { TextField, Autocomplete, CircularProgress } from '@mui/material'
import _debounce from 'lodash/debounce'

import { useSprSearchQuery } from 'services/hooks/supplierPreferenceRules/useSprSearchQuery'

const DEBOUNCE_TIME_MS = 1000

type AutocompleteSearchProps = {
  partNumberClassIds: string[]
  onChangeTerm: (value: string) => void
}

const AutocompleteSearch = ({
  partNumberClassIds,
  onChangeTerm,
}: AutocompleteSearchProps) => {
  const [open, setOpen] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [term, setTerm] = useState('')
  const strPartNumberClassIds = partNumberClassIds.toString()
  const { data: searchSprResult, isFetching } = useSprSearchQuery({
    term,
    partNumberClassIds: strPartNumberClassIds,
  })

  const debouncedUpdateData = useCallback(
    _debounce((value: string) => {
      setTerm(value)
    }, DEBOUNCE_TIME_MS),
    []
  )

  const onChangeSearchField = async (e) => {
    setSearchValue(e.target.value)
    debouncedUpdateData(e.target.value)
  }

  const onChangeValue = (event, value) => {
    onChangeTerm(value)
  }

  return (
    <Autocomplete
      id='asynchronous-demo'
      style={{ width: 200 }}
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      options={searchSprResult?.search.terms || []}
      loading={isFetching}
      onChange={onChangeValue}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Search'
          variant='outlined'
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isFetching ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          value={searchValue}
          onChange={onChangeSearchField}
        />
      )}
    />
  )
}

export default AutocompleteSearch
